//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const settings = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getSettings(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      const res = await fetch(`${config.host}/cdr-panel/api/settings`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function editSettings(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/api/settings/update`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getSettings,
    editSettings,
  };
};

export default settings;
